module.exports = __webpack_public_path__ + "static/media/general-03.c73f6f57.jpg";